@if (paging != null && (paging.hasNext || paging.hasPrevious)) {
  <div class="paging">
    @if (paging.hasPrevious) {
      <a (click)="gotToPage(paging.currentPage - 1)">&#60; Previous</a>
    }
    &nbsp;&nbsp;
    @if (paging.hasNext) {
      <a  (click)="gotToPage(paging.currentPage + 1)">Next &#62;</a>
    }
    @if (showPageLabel) {
      <span>
        &nbsp;&nbsp;Page {{ paging.currentPage }} of {{ paging.totalPages }}
      </span>
    }
  </div>
}
